import React, { useState, useEffect } from 'react';
import './ConviteEvento.css';
import './ConviteEventoColombia.css';
import HeroImg from '../../assets/convite-evento/image-colombia.png';
import GoogleMapsLogo from '../../assets/logos/googlemaps-rodape.png';
import WazeLogo from '../../assets/logos/waze-rodape.png';
import GoogleCloudLogo from '../../assets/logos/google-cloud.png';
import GoogleEducationLogo from '../../assets/logos/google-education.png';
import CalrizLogo from '../../assets/logos/logo-oficial-calriz.png';
import SmartCloudLogo from '../../assets/logos/4smart-rodape.png';
import RedLogo from '../../assets/logos/LogoRed.png';
import FederacionLogo from '../../assets/logos/logo_federacion.png';
import Seo from '../../seo/Seo';

const REGISTRATION_URL = 'https://backend.calriz.com/api/registro-evento';
const EVENT_DATE = new Date('2026-10-28T13:00:00-05:00');

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function calcTimeLeft(): TimeLeft {
  const diff = EVENT_DATE.getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
}

function isValidTelefono(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}

const agendaItems = [
  { time: '1:00 p. m. a 1:30 p. m.', title: 'Registro, bienvenida y recepción' },
  { time: '1:30 p. m. a 1:45 p. m.', title: 'Apertura del encuentro' },
  { time: '1:45 p. m. a 2:00 p. m.', title: 'Introducción a Google para Ciudades' },
  { time: '2:00 p. m. a 2:15 p. m.', title: 'El niño' },
  { time: '2:15 p. m. a 2:35 p. m.', title: 'Caso de éxito: la experiencia de Bogotá' },
  { time: '2:35 p. m. a 2:50 p. m.', title: 'Comunidad de Waze' },
  { time: '2:50 p. m. a 3:10 p. m.', title: 'Google Cloud: datos y tecnología para ciudades' },
  { time: '3:10 p. m. a 3:30 p. m.', title: 'Go Data: datos integrados para una gestión urbana más inteligente' },
  { time: '3:30 p. m. a 3:50 p. m.', title: 'Pausa para café y networking' },
  { time: '3:50 p. m. a 4:10 p. m.', title: 'Google for Education: tecnología para fortalecer la educación municipal' },
  { time: '4:10 p. m. a 4:40 p. m.', title: 'SEDAP+: datos seguros para apoyar las políticas públicas' },
  { time: '4:40 p. m. a 5:00 p. m.', title: 'Conversación abierta, conclusiones y cierre' },
];

const publicoItems = [
  'Movilidad y transporte',
  'Planeación y desarrollo urbano',
  'Tecnología e innovación',
  'Seguridad vial',
  'Sostenibilidad',
  'Educación',
  'Gestión y modernización de servicios públicos',
];

const footerLogos = [
  { src: GoogleMapsLogo, alt: 'Google Maps', tall: false },
  { src: WazeLogo, alt: 'Waze', tall: false },
  { src: GoogleCloudLogo, alt: 'Google Cloud', tall: false },
  { src: GoogleEducationLogo, alt: 'Google for Education', tall: false },
  { src: CalrizLogo, alt: 'Calriz', tall: false },
  { src: SmartCloudLogo, alt: '4smart cloud', tall: true },
  { src: RedLogo, alt: 'Red', tall: true },
  { src: FederacionLogo, alt: 'Federación', tall: true },
];

export default function ConviteEventoColombia() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calcTimeLeft);

  const [nome, setNome] = useState('');
  const [cargo, setCargo] = useState('');
  const [organizacao, setOrganizacao] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [acessibilidade, setAcessibilidade] = useState<'no' | 'si'>('no');
  const [acessibilidadeDetalhe, setAcessibilidadeDetalhe] = useState('');
  const [alimentar, setAlimentar] = useState<'no' | 'si'>('no');
  const [alimentarDetalhe, setAlimentarDetalhe] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState<{
    nome?: string;
    cargo?: string;
    organizacao?: string;
    email?: string;
    telefone?: string;
    acessibilidade?: string;
    alimentar?: string;
    geral?: string;
  }>({});

  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(calcTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);

  function scrollToForm(e?: React.MouseEvent) {
    if (e) e.preventDefault();
    document.getElementById('inscripcion')?.scrollIntoView({ behavior: 'smooth' });
  }

  function validate() {
    const next: typeof errors = {};
    if (!nome.trim()) next.nome = 'Ingrese el nombre completo.';
    if (!cargo.trim()) next.cargo = 'Ingrese el cargo.';
    if (!organizacao.trim()) next.organizacao = 'Ingrese la entidad o institución.';
    if (!email.trim()) next.email = 'Ingrese el correo electrónico.';
    else if (!isValidEmail(email)) next.email = 'Correo electrónico inválido.';
    if (!isValidTelefono(telefone)) next.telefone = 'Teléfono inválido. Incluya el indicativo.';
    if (acessibilidade === 'si' && !acessibilidadeDetalhe.trim()) {
      next.acessibilidade = 'Por favor, especifique la adaptación necesaria.';
    }
    if (alimentar === 'si' && !alimentarDetalhe.trim()) {
      next.alimentar = 'Por favor, especifique la restricción alimentaria.';
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      email,
      nome,
      organizacao,
      cargo,
      telefone,
      cidade: 'colombia',
      acessibilidade: acessibilidade === 'si' ? acessibilidadeDetalhe.trim() : 'No',
      restricaoAlimentar: alimentar === 'si' ? alimentarDetalhe.trim() : 'No',
    };

    setSubmitting(true);
    try {
      const res = await fetch(REGISTRATION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Network response not ok');
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setErrors({ geral: 'Error al enviar la inscripción. Inténtelo de nuevo.' });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="rsvp-page col-page">
      <Seo title="Google para Ciudades – Colombia" description="Encuentro presencial de Calriz y Google en las oficinas de Google Bogotá, el 28 de octubre de 2026." path="/google-para-ciudades-colombia" noindex />

      {/* Navbar */}
      <nav className="rsvp-nav">
        <div className="rsvp-nav-inner">
          <div className="rsvp-nav-left">
            
          </div>

          <div className="rsvp-nav-right">
            <span className="rsvp-countdown">
              Comienza en{' '}
              <strong>
                {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
              </strong>
            </span>
            <a href="#inscripcion" onClick={scrollToForm} className="rsvp-btn-pill">
              Inscríbase
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="rsvp-hero">
        <div className="rsvp-hero-inner">
          <div className="rsvp-hero-content">
            <h1 className="rsvp-hero-title">
              Google para Ciudades – Colombia
            </h1>
            <p className="rsvp-hero-subtitle">
              Datos y tecnología para una gestión urbana más inteligente
            </p>
            <p className="rsvp-hero-lead">
              Un encuentro exclusivo para líderes del sector público interesados en conectar
              información, geolocalización y tecnología para responder de manera más ágil y
              estratégica a los desafíos de sus ciudades.
            </p>
            <div className="rsvp-hero-meta">
              <div className="rsvp-hero-meta-item">
                <svg className="rsvp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span className="col-hero-meta-text">
                  <strong>28 de octubre de 2026</strong>
                  <span>1:00 p. m. a 5:00 p. m.</span>
                </span>
              </div>
              <div className="rsvp-hero-meta-item">
                <svg className="rsvp-icon col-icon--green" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
                <span className="col-hero-meta-text">
                  <strong className="col-hero-meta-text--strong"> Oficinas de Google Bogotá

</strong>
                 <span>Carrera 11a #94-25, Centro Empresarial Oxo Center</span>
                </span>
              </div>
            </div>
            <a href="#inscripcion" onClick={scrollToForm} className="rsvp-btn-pill col-btn-hero">
              Solicitar mi participación
            </a>
          </div>
          <div className="rsvp-hero-image rsvp-hero-image--square">
            <img src={HeroImg} alt="Google para Ciudades" />
          </div>
          <a href="#inscripcion" onClick={scrollToForm} className="rsvp-btn-pill rsvp-hero-cta col-btn-hero">
            Solicitar mi participación
          </a>
        </div>
      </section>

      {/* Descripción */}
      <section className="rsvp-section col-section">
        <div className="rsvp-section-inner">
          <p className="rsvp-description-lead">
            Una visión integral para transformar la gestión de las ciudades
          </p>
          <p className="rsvp-description-body">
            Las ciudades enfrentan desafíos cada vez más complejos en áreas como movilidad,
            planificación urbana, prestación de servicios públicos y educación. Para responder a
            estas demandas, es necesario conectar los datos disponibles, comprender mejor lo que
            ocurre en el territorio y convertir la información en decisiones concretas.
          </p>
          <p className="rsvp-description-body">
            En <strong>Google para Ciudades – Colombia</strong>, líderes de gobiernos locales y
            especialistas se reunirán para conocer cómo las soluciones de{' '}
            <strong>Google Maps</strong>, <strong>Waze</strong>, <strong>Google Cloud</strong> y{' '}
            <strong>Google for Education</strong> pueden trabajar de forma integrada, para apoyar
            una gestión pública más eficiente, preventiva y conectada.
          </p>

          <h3 className="rsvp-why-title">Durante el encuentro, exploraremos tres perspectivas</h3>
          <ul className="rsvp-bullets">
            <li>
              <strong>Movilidad más inteligente</strong> — Datos y soluciones de geolocalización
              para comprender los desplazamientos, reducir el congestionamiento, fortalecer la
              seguridad vial y mejorar la planeación urbana.
            </li>
            <li>
              <strong>Gestión pública más ágil y eficiente</strong> — Tecnología en la nube para
              integrar información, modernizar procesos internos y ofrecer servicios más eficientes
              a la ciudadanía.
            </li>
            <li>
              <strong>Educación preparada para el futuro</strong> — Herramientas diseñadas para
              fortalecer las redes de enseñanza, apoyar a educadores y ampliar las posibilidades de
              aprendizaje en las ciudades.
            </li>
          </ul>

          <h3 className="rsvp-why-title">¿A quién está dirigido?</h3>
          <p className="rsvp-why-subtitle">
            Este encuentro está dirigido a autoridades, líderes y equipos técnicos de gobiernos
            locales que trabajan en áreas como:
          </p>
          <ul className="rsvp-bullets">
            {publicoItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* Agenda */}
      <section className="rsvp-section rsvp-agenda col-section">
        <div className="rsvp-section-inner">
          <h2 className="rsvp-section-title">Agenda</h2>
          <p className="col-agenda-subtitle">Conozca la agenda</p>
          <div className="rsvp-agenda-list">
            {agendaItems.map((item, i) => (
              <div key={i} className="rsvp-agenda-item">
                <span className="rsvp-agenda-time">{item.time}</span>
                <span className="rsvp-agenda-title">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário */}
      <section className="col-form-section" id="inscripcion">
        <div className="col-form-grid">
          <div className="col-form-intro">
            <h2>Participe en esta conversación sobre el futuro de las ciudades</h2>
            <p>Complete el formulario para solicitar su participación.</p>
          </div>

          {submitted ? (
            <div className="col-form-card">
              <div className="col-form-success">
                <svg viewBox="0 0 24 24" fill="none" stroke="#1a73e8" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
                <h3>¡Solicitud enviada!</h3>
                <p>
                  Gracias. Los cupos son limitados y la inscripción está sujeta a confirmación.
                  Recibirá un correo electrónico con la respuesta.
                </p>
              </div>
            </div>
          ) : (
            <form className="col-form-card" onSubmit={handleSubmit} noValidate>
              <div className="col-field">
                <label htmlFor="col-nome">Nombre completo</label>
                <input
                  id="col-nome"
                  type="text"
                  value={nome}
                  onChange={e => setNome(e.target.value)}
                  className={errors.nome ? 'col-input--error' : ''}
                  maxLength={80}
                />
              </div>
              {errors.nome && <p className="col-field-error">{errors.nome}</p>}

              <div className="col-field">
                <label htmlFor="col-cargo">Cargo</label>
                <input
                  id="col-cargo"
                  type="text"
                  value={cargo}
                  onChange={e => setCargo(e.target.value)}
                  className={errors.cargo ? 'col-input--error' : ''}
                  maxLength={80}
                />
              </div>
              {errors.cargo && <p className="col-field-error">{errors.cargo}</p>}

              <div className="col-field">
                <label htmlFor="col-entidad">Entidad o institución</label>
                <input
                  id="col-entidad"
                  type="text"
                  value={organizacao}
                  onChange={e => setOrganizacao(e.target.value)}
                  className={errors.organizacao ? 'col-input--error' : ''}
                  maxLength={80}
                />
              </div>
              {errors.organizacao && <p className="col-field-error">{errors.organizacao}</p>}

              <div className="col-field">
                <label htmlFor="col-email">Correo electrónico corporativo</label>
                <input
                  id="col-email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className={errors.email ? 'col-input--error' : ''}
                  maxLength={80}
                />
              </div>
              {errors.email && <p className="col-field-error">{errors.email}</p>}

              <div className="col-field">
                <label htmlFor="col-tel">Teléfono o WhatsApp</label>
                <input
                  id="col-tel"
                  type="tel"
                  value={telefone}
                  onChange={e => setTelefone(e.target.value.replace(/[^\d+\s()-]/g, '').slice(0, 20))}
                  className={errors.telefone ? 'col-input--error' : ''}
                  placeholder="+57 300 000 0000"
                />
              </div>
              {errors.telefone && <p className="col-field-error">{errors.telefone}</p>}

              {/* Accesibilidad */}
              <div className="col-question">
                <p className="col-question-label">
                  ¿Requiere alguna adaptación de accesibilidad o apoyo especial para participar del
                  evento?
                </p>
                <p className="col-question-help">
                  Por ejemplo: apoyo para movilidad, acceso para silla de ruedas, asistencia para
                  desplazamiento u otra necesidad.
                </p>
                <div className="col-choices">
                  <label className={`col-choice${acessibilidade === 'no' ? ' col-choice--active' : ''}`}>
                    <input
                      type="radio"
                      name="col-acessibilidade"
                      checked={acessibilidade === 'no'}
                      onChange={() => setAcessibilidade('no')}
                    />
                    <span>No</span>
                  </label>
                  <label className={`col-choice${acessibilidade === 'si' ? ' col-choice--active' : ''}`}>
                    <input
                      type="radio"
                      name="col-acessibilidade"
                      checked={acessibilidade === 'si'}
                      onChange={() => setAcessibilidade('si')}
                    />
                    <span>Sí. Por favor, especifique:</span>
                  </label>
                </div>
                {acessibilidade === 'si' && (
                  <textarea
                    className="col-textarea"
                    value={acessibilidadeDetalhe}
                    onChange={e => setAcessibilidadeDetalhe(e.target.value)}
                    placeholder="Describa la adaptación necesaria"
                    maxLength={300}
                  />
                )}
                {errors.acessibilidade && <p className="col-field-error" style={{ gridColumn: 'auto' }}>{errors.acessibilidade}</p>}
              </div>

              {/* Restricción alimentaria */}
              <div className="col-question">
                <p className="col-question-label">
                  ¿Tiene alguna alergia, intolerancia o restricción alimentaria que debamos
                  considerar?
                </p>
                <div className="col-choices">
                  <label className={`col-choice${alimentar === 'no' ? ' col-choice--active' : ''}`}>
                    <input
                      type="radio"
                      name="col-alimentar"
                      checked={alimentar === 'no'}
                      onChange={() => setAlimentar('no')}
                    />
                    <span>No</span>
                  </label>
                  <label className={`col-choice${alimentar === 'si' ? ' col-choice--active' : ''}`}>
                    <input
                      type="radio"
                      name="col-alimentar"
                      checked={alimentar === 'si'}
                      onChange={() => setAlimentar('si')}
                    />
                    <span>Sí. Por favor, especifique:</span>
                  </label>
                </div>
                {alimentar === 'si' && (
                  <textarea
                    className="col-textarea"
                    value={alimentarDetalhe}
                    onChange={e => setAlimentarDetalhe(e.target.value)}
                    placeholder="Describa la alergia, intolerancia o restricción"
                    maxLength={300}
                  />
                )}
                {errors.alimentar && <p className="col-field-error" style={{ gridColumn: 'auto' }}>{errors.alimentar}</p>}
              </div>

              {errors.geral && <p className="col-field-error" style={{ gridColumn: 'auto' }}>{errors.geral}</p>}

              <button type="submit" className="col-submit" disabled={submitting}>
                {submitting ? 'Enviando…' : 'Solicitar mi inscripción'}
              </button>
              <p className="col-form-note">
                Los cupos son limitados y la inscripción está sujeta a confirmación.
              </p>
            </form>
          )}
        </div>
      </section>

      {/* Rodapé de logos */}
      <footer className="col-logos-footer">
        <div className="col-logos-inner">
          {footerLogos.map((logo, i) => (
            <div key={i} className={`col-logo${logo.tall ? ' col-logo--tall' : ''}`}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </footer>

    </div>
  );
}
